import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { S25RouterLinkDirective } from "../../s25-nav-bar/s25.router.link.directive";

/**
 * An invoice name linking to its event's pricing page. A real href, so middle-click and the
 * browser's own context menu can open it in a new tab.
 */
@TypeManagerDecorator("s25-ng-org-invoice-link-cell")
@Component({
    selector: "s25-ng-org-invoice-link-cell",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25RouterLinkDirective],
    template: `
        <a
            s25-ng-router-link
            [stateName]="'eventPricing'"
            [stateParams]="{ itemId: eventId(), evBillId: invoiceId() }"
            [attr.id]="elementId() || null"
            >{{ label() }}</a
        >
    `,
})
export class OrgInvoiceLinkCellComponent {
    readonly label = input.required<string>();
    readonly eventId = input.required<number>();
    readonly invoiceId = input.required<number>();
    /** Named so the row has a focus destination */
    readonly elementId = input("");
}
